import { useTenant } from '../../../contexts/TenantContext'
import { useCurrency } from './shared'
import { t } from '../../../i18n'

// A printed bistro menu: a single cream "paper" sheet with a double rule
// border, centered small-caps headings, and two columns of dishes with
// dotted leaders to the price. No photos - the words carry it.
export default function ElegantTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const tenant = useTenant()
  const categories = menu.filter(c => c.items?.length)

  return (
    <div className="max-w-5xl mx-auto py-4" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
      <div className="bg-[#fdfaf3] shadow-[0_20px_60px_-30px_rgba(60,40,20,0.35)] p-3 md:p-4">
        <div className="border-[3px] border-double border-[color:var(--brand,#b89b6a)] px-6 md:px-16 py-12 md:py-16 text-[#2b2419]">
          <header className="text-center mb-14">
            <p className="text-xs tracking-[0.5em] uppercase text-[color:var(--brand,#9a7f52)]">{t("Carte du jour")}</p>
            <h1 className="text-5xl md:text-6xl mt-4" style={{ fontVariant: 'small-caps' }}>{tenant.name || t("Our Menu")}</h1>
            <p className="text-[color:var(--brand,#9a7f52)] text-xl mt-4" aria-hidden="true">— ✦ —</p>
            {table && <p className="text-sm tracking-[0.3em] uppercase text-[color:var(--brand,#7a6647)] mt-2">{t("Table")} {table}</p>}
          </header>

          <div className="md:columns-2 md:gap-16">
            {categories.map(c => (
              <section key={c.id} className="break-inside-avoid mb-12">
                <h2 className="text-center text-2xl tracking-[0.2em] uppercase mb-6" style={{ fontVariant: 'small-caps' }}>{c.name}</h2>
                <ul className="space-y-5">
                  {c.items.map(item => (
                    <li key={item.id}>
                      <button onClick={() => onSelectItem(item)} className="w-full text-start group">
                        <span className="flex items-baseline gap-2">
                          <span className="text-lg font-semibold group-hover:text-[color:var(--brand,#8a6a36)] transition-colors">{item.name}</span>
                          <span className="flex-1 border-b border-dotted border-[color:var(--brand,#b89b6a)] translate-y-[-5px]" aria-hidden="true" />
                          <span className="text-lg whitespace-nowrap">{Number(item.price || 0).toFixed(2)} <small className="text-xs text-[color:var(--brand,#9a7f52)]">{currency}</small></span>
                        </span>
                        {item.description && <span className="block italic text-[#6d5d45] text-[15px] leading-snug mt-1 pe-10">{t(item.description)}</span>}
                      </button>
                      <button onClick={() => addItem(item)} className="text-[11px] tracking-[0.25em] uppercase text-[color:var(--brand,#8a6a36)] mt-1 hover:underline" style={{ fontFamily: 'Inter, sans-serif' }}>
                        {t("Add to order")}
                      </button>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>

          <p className="text-center italic text-[color:var(--brand,#7a6647)] mt-6">{t("Please let us know of any allergies before ordering.")}</p>
        </div>
      </div>
    </div>
  )
}
